import gql from 'graphql-tag'

export const UPSERT_RATING_MUTATION = gql`
mutation upsertRating($data: RatingInput!){
  upsertRating(data: $data){
    success
    created
  }
}`;